import { GzDialogWebComponent } from '../../ui/gzDialog';
import { ToastSeverity } from '../../ui/gzToastNotification/type';
import { GzToastNotificationWebComponent } from '../../ui/gzToastNotification';

export function showCancelWarningDialog(confirmCallback: () => void) {
  const windowBodyHtml = `
      <p>
        ${this.dependencies.translateFn('Changes you have made will be lost.')}
      </p>`;

  const windowFooterHtml = `<gz-button id='confirm' type='outline' color='negative' class='mr-2'>
       ${this.dependencies.translateFn('Discard')}
      </gz-button>
      <gz-button id='cancel' type='outline' color='secondary'>
        ${this.dependencies.translateFn('Keep changes')}
      </gz-button>`;

  const windowTitle = this.dependencies.translateFn('Discard changes?');

  GzDialogWebComponent.computeCustomDialog(windowBodyHtml, windowFooterHtml, windowTitle, null, confirmCallback);
}

export function showToast(severity: ToastSeverity, message: string, actionConfig: null | object = null) {
  let toastConfig = {
    message: message,
    severity: severity,
  };

  if (actionConfig) {
    toastConfig = {
      ...toastConfig,
      ...actionConfig,
    };
  }

  GzToastNotificationWebComponent.buildToastWrapperElement(toastConfig);
}
